import React from "react";

export default function OdooDevelopment() {
  return (
    <div className="prod_body">
      <div className="prod_main_body py-3">
        Odoo 18 is the 18th version of Odoo's Enterprise Resource Planning (ERP)
        software, released in October 2024, that offers a modular platform for
        managing various business operations, including accounting, CRM,
        inventory, HR, and e-commerce, with a focus on advanced AI-driven
        features, enhanced user experience, and improved workflow automation.
        Key improvements include AI-powered reporting, streamlined inventory
        management with features like multi-scan and real-time tracking,
        advanced project management tools, optimized user interfaces with
        quicker navigation, and enhanced e-commerce capabilities.
      </div>

      <div className="prod_main_body py-3">
        Our organization is now capable of offering Odoo ERP solutions to almost
        all industry verticals.
      </div>

      <div className="prod_main_head2 pt-3">Our Services</div>
      <ul className="prod_main_body py-3">
        <li>
          <b style={{ color: "#4ea5ff" }}>Consulting Services:</b> We provide professional consulting to
          implement Odoo modules tailored to your business.
        </li>

        <li>
          <b style={{ color: "#4ea5ff" }}>Implementation Services:</b> Full Odoo deployment with
          configuration for your business workflows.
        </li>

        <li>
          <b style={{ color: "#4ea5ff" }}>Integration Services:</b> Integrate Odoo with other systems for
          seamless operations.
        </li>

        <li>
          <b style={{ color: "#4ea5ff" }}>Support Services:</b> Post-implementation support to keep your ERP
          running smoothly.
        </li>
      </ul>

      <div className="prod_main_body py-3">
        We have 25+ SMEs well trained in Odoo ERP modules who can transform your
        business to the next level. We can implement Odoo 18 with
        out-of-the-box features or with customizations based on business
        requirements. We follow a phase-wise approach while implementing Odoo
        ERP.
      </div>

      {/* -------------------- PHASE 1 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 1 – Discovery and Planning
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>Define Business Goals:</b> Clearly outline objectives.
        </li>
        <li>
          <b>Process Analysis / Gap Analysis:</b> Identify gaps and efficiencies.
        </li>
        <li>
          <b>Design Technical & Business Approach:</b> Architecture planning.
        </li>
        <li>
          <b>Project Planning:</b> Develop timelines and resources.
        </li>
        <li>
          <b>Sign Off:</b> Approve agreed scope and timelines.
        </li>
      </ul>

      {/* -------------------- PHASE 2 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 2 – Configuration and Customization
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>System Setup:</b> Install and configure necessary Odoo modules.
        </li>
        <li>
          <b>Personalization:</b> Create custom fields, reports, and workflows.
        </li>
      </ul>

      {/* -------------------- PHASE 3 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 3 – Integration
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>System Integration:</b> Connect Odoo with other software.
        </li>
      </ul>

      {/* -------------------- PHASE 4 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 4 – Testing & Quality Assurance
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>Testing:</b> Unit and integration testing to resolve issues.
        </li>
        <li>
          <b>User Acceptance Testing (UAT):</b> End-user testing for usability.
        </li>
      </ul>

      {/* -------------------- PHASE 5 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 5 – Go Live / Deployment
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>Final Preparation:</b> Data migration and readiness check.
        </li>
        <li>
          <b>End User Training:</b> Provide user training.
        </li>
        <li>
          <b>System Launch:</b> Deploy the fully tested system.
        </li>
        <li>
          <b>Sign Off:</b> Final deployment approval.
        </li>
      </ul>

      {/* -------------------- PHASE 6 -------------------- */}
      <div className="prod_main_head pt-1" style={{ fontSize: "1.4rem" }}>
        Phase - 6 – Business as Usual
      </div>
      <ul className="prod_main_body py-3">
        <li>
          <b>Support:</b> Ongoing support to users for immediate issues.
        </li>
        <li>
          <b>Continuous Improvement:</b> Collect feedback and optimize
          performance.
        </li>
        <li>
          <b>Updates & Upgrades:</b> Manage future Odoo version upgrades and
          patches.
        </li>
      </ul>

      {/* -------------------- PHASES TABLE -------------------- */}
      <div className="phases-section">
        <div className="container py-5">
          <h2 className="text-center mb-4 main-title">
            <span className="title-highlight">Phases of Odoo Implementation</span>
          </h2>
          <p className="text-center subtitle">A comprehensive roadmap to successful Odoo deployment</p>

          {/* Table Structure */}
          <div className="table-wrapper">
            <table className="table table-bordered phases-table">
              <thead>
                <tr className="table-header">
                  <th className="phase-header">
                    <div className="phase-number">1</div>
                    <span>PHASE 1</span>
                  </th>
                  <th className="phase-header">
                    <div className="phase-number">2</div>
                    <span>PHASE 2</span>
                  </th>
                  <th className="phase-header">
                    <div className="phase-number">3</div>
                    <span>PHASE 3</span>
                  </th>
                  <th className="phase-header">
                    <div className="phase-number">4</div>
                    <span>PHASE 4</span>
                  </th>
                  <th className="phase-header">
                    <div className="phase-number">5</div>
                    <span>PHASE 5</span>
                  </th>
                  <th className="phase-header">
                    <div className="phase-number">6</div>
                    <span>PHASE 6</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="table-cell" data-phase="PHASE 1">
                    <div className="cell-content">
                      <h5>Discovery and Planning</h5>
                      <div className="line"></div>
                      <ul>
                        <li>Define Business Goals</li>
                        <li>Process Analysis / Gap Analysis</li>
                        <li>Design technical and business approach</li>
                        <li>Identify the required Implementation and Deployment architecture</li>
                        <li>Project Planning</li>
                        <li>Sign off</li>
                      </ul>
                    </div>
                  </td>
                  <td className="table-cell" data-phase="PHASE 2">
                    <div className="cell-content">
                      <h5>Configuration and Customization</h5>
                      <div className="line"></div>
                      <ul>
                        <li>System Setup</li>
                        <li>Personalization</li>
                      </ul>
                    </div>
                  </td>
                  <td className="table-cell" data-phase="PHASE 3">
                    <div className="cell-content">
                      <h5>Integration</h5>
                      <div className="line"></div>
                      <ul>
                        <li>System Integration</li>
                      </ul>
                    </div>
                  </td>
                  <td className="table-cell" data-phase="PHASE 4">
                    <div className="cell-content">
                      <h5>Testing & Quality Assurance</h5>
                      <div className="line"></div>
                      <ul>
                        <li>Testing</li>
                        <li>User Acceptance Testing (UAT)</li>
                      </ul>
                    </div>
                  </td>
                  <td className="table-cell" data-phase="PHASE 5">
                    <div className="cell-content">
                      <h5>Go Live / Deployment</h5>
                      <div className="line"></div>
                      <ul>
                        <li>Final Preparation</li>
                        <li>End User Training</li>
                        <li>System Launch</li>
                        <li>Sign Off</li>
                      </ul>
                    </div>
                  </td>
                  <td className="table-cell" data-phase="PHASE 6">
                    <div className="cell-content">
                      <h5>Business as Usual</h5>
                      <div className="line"></div>
                      <ul>
                        <li>Support</li>
                        <li>Continuous Improvement</li>
                        <li>Updates and Upgrades</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Progress indicator */}
          <div className="progress-indicator">
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
            <p className="progress-text">Complete Implementation Journey</p>
          </div>
        </div>
      </div>

      {/* ==================== STYLES ==================== */}
      <style>{`
        /* =======================
           SECTION BACKGROUND
        ======================= */
        .phases-section {
          background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
          padding: 40px 0;
          position: relative;
          overflow: hidden;
        }

        .prod_main_body li {
          font-size: 1.2rem;
          line-height: 1.35;
        }
          
        .phases-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: 
            radial-gradient(circle at 20% 50%, rgba(93, 153, 232, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(63, 177, 255, 0.05) 0%, transparent 50%);
          pointer-events: none;
        }

        /* =======================
           MAIN TITLE
        ======================= */
        .main-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: #2c3e50;
          margin-bottom: 1rem;
          position: relative;
          z-index: 1;
          animation: fadeInDown 0.8s ease-out;
        }

        .title-highlight {
          background: linear-gradient(135deg, #63b8ff 0%, #0077b6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          position: relative;
        }

        .subtitle {
          font-size: 1.1rem;
          color: #7f8c8d;
          margin-bottom: 3rem;
          font-weight: 400;
          animation: fadeInUp 0.8s ease-out;
        }

        /* =======================
           TABLE WRAPPER
        ======================= */
        .table-wrapper {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          padding: 20px;
          overflow: hidden;
          animation: fadeInScale 0.8s ease-out;
        }

        /* =======================
           TABLE BASE
        ======================= */
        .phases-table {
          width: 100%;
          table-layout: fixed;
          border-collapse: separate;
          border-spacing: 0;
          margin-bottom: 0;
          font-family: 'Segoe UI', 'Arial', sans-serif;
        }

        .phases-table th,
        .phases-table td {
          padding: 25px 20px;
          text-align: left;
          vertical-align: top;
          font-weight: normal;
          border: none;
          width: 16.66%;
          position: relative;
        }

        .phases-table td {
          border-right: 2px solid #e8ecf1;
        }

        .phases-table td:last-child {
          border-right: none;
        }

        /* =======================
           TABLE HEADERS - MODERN DESIGN
        ======================= */
        .table-header {
          background: linear-gradient(135deg, #4da3d1 0%, #63b8ff 100%);
          position: relative;
        }

        .phase-header {
          color: #fff;
          font-size: 1rem;
          font-weight: 700;
          text-transform: uppercase;
          text-align: center;
          padding: 25px 15px;
          white-space: nowrap;
          width: 16.66%;
          position: relative;
          border-right: 2px solid rgba(255, 255, 255, 0.3);
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .phase-header:last-child {
          border-right: none;
        }

        .phase-header:hover {
          background: linear-gradient(135deg, #4da3d1 0%, #63b8ff 100%);
          transform: translateY(-2px);
        }

        .phase-number {
  display: inline-block;
  width: 40px; /* Adjusted size of the circle */
  height: 40px; /* Ensured it's a perfect circle */
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  line-height: 40px; /* Vertically center the number */
  font-size: 1.1rem; /* Font size adjusted for better fit */
  font-weight: 800;
  margin-bottom: 8px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center; /* Center the number horizontally */
  position: relative;
  left: -8px; /* Adjust the positioning slightly to move it left */
}
        /* =======================
           TABLE CELLS - ENHANCED
        ======================= */
        .table-cell {
          background: linear-gradient(180deg, #a1d6f6 0%, #d1eaf9 100%);
          font-size: 1.05rem;
          line-height: 1.8;
          padding: 30px 20px;
          word-wrap: break-word;
          vertical-align: top;
          width: 16.66%;
          transition: all 0.3s ease;
          position: relative;
        }

        .table-cell:hover {
          background: linear-gradient(180deg, #e8faff 0%, #c1e8f9 100%);
          box-shadow: inset 0 0 0 2px #63b8ff;
          transform: translateY(-2px);
        }

        .cell-content {
          position: relative;
          z-index: 1;
        }

        .table-cell h5 {
          color: #0077b6;
          font-size: 1.2rem;
          font-weight: 700;
          margin: 0 0 15px 0;
          height: 72px;
          line-height: 1.4;
          display: flex;
          align-items: flex-start;
          position: relative;
          padding-left: 10px;
        }

        .table-cell h5::before {
          content: '';
          position: absolute;
          left: 0;
          top: 5px;
          width: 4px;
          height: 28px;
          background: linear-gradient(180deg, #0077b6 0%, #63b8ff 100%);
          border-radius: 2px;
        }

        /* =======================
           DIVIDER LINE - GRADIENT
        ======================= */
        .line {
          height: 3px;
          background: linear-gradient(90deg, #0077b6 0%, #63b8ff 100%);
          margin: 0 0 20px 0;
          border-radius: 2px;
          box-shadow: 0 2px 8px rgba(63, 177, 255, 0.3);
          position: relative;
          overflow: hidden;
        }

        .line::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
          animation: shimmer 3s infinite;
        }

        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        /* =======================
           LIST STYLES WITH ANIMATED TICKS
        ======================= */
        .table-cell ul {
          list-style: none;
          padding-left: 0;
          margin: 0;
        }

        .table-cell ul li {
          padding: 10px 0 10px 35px;
          font-size: 0.85rem;
          line-height: 1.1;
          color: #083f75ff;
          position: relative;
          transition: all 0.3s ease;
        }

        .table-cell ul li:hover {
          padding-left: 40px;
          color: #0077b6;
        }

        .table-cell ul li::before {
          content: "✓";
          position: absolute;
          left: 0;
          top: 10px;
          width: 24px;
          height: 24px;
          font-size: 1.2rem;
          font-weight: bold;
          color: #fff;
          background: linear-gradient(135deg, #4da3d1 0%, #63b8ff 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(63, 177, 255, 0.3);
          transition: all 0.3s ease;
        }

        .table-cell ul li:hover::before {
          transform: scale(1.15) rotate(360deg);
          box-shadow: 0 4px 12px rgba(63, 177, 255, 0.5);
        }

        /* =======================
           PROGRESS INDICATOR
        ======================= */
        .progress-indicator {
          margin-top: 40px;
          text-align: center;
          animation: fadeInUp 1s ease-out;
        }

        .progress-bar {
          width: 100%;
          max-width: 800px;
          height: 8px;
          background: #e8ecf1;
          border-radius: 10px;
          margin: 0 auto 15px;
          overflow: hidden;
          position: relative;
          box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #0077b6 0%, #63b8ff 50%, #4da3d1 100%);
          border-radius: 10px;
          animation: progressAnimation 3s ease-out forwards;
          box-shadow: 0 0 20px rgba(63, 177, 255, 0.5);
        }

        @keyframes progressAnimation {
          from { width: 0; }
          to { width: 100%; }
        }

        .progress-text {
          font-size: 0.95rem;
          color: #7f8c8d;
          font-weight: 600;
          margin: 0;
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        /* =======================
           RESPONSIVE DESIGN - TABLETS
        ======================= */
        @media (max-width: 1200px) {
          .main-title {
            font-size: 2.2rem;
          }
          
          .phases-table th,
          .phases-table td {
            padding: 20px 15px;
          }
          
          .phase-header {
            font-size: 0.9rem;
            padding: 20px 12px;
          }
          
          .phase-number {
            width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 1rem;
          }
          
          .table-cell {
            font-size: 1rem;
            padding: 25px 15px;
          }
          
          .table-cell h5 {
            font-size: 1.1rem;
            height: 68px;
          }
          
          .table-cell ul li {
            font-size: 0.95rem;
            padding: 8px 0 8px 32px;
          }
        }

        /* =======================
           MOBILE RESPONSIVE - CARD VIEW
        ======================= */
        @media (max-width: 768px) {
          .main-title {
            font-size: 1.8rem;
          }
          
          .subtitle {
            font-size: 1rem;
            margin-bottom: 2rem;
          }
          
          .table-wrapper {
            padding: 15px;
            border-radius: 12px;
          }
          
          /* Hide desktop table header */
          .phases-table thead {
            display: none;
          }
          
          /* Stack table vertically */
          .phases-table,
          .phases-table tbody,
          .phases-table tr {
            display: block;
            width: 100%;
          }
          
          /* Each phase becomes a card */
          .phases-table td {
            display: block;
            width: 100% !important;
            margin-bottom: 25px;
            border: none;
            border-radius: 16px;
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
            padding: 0 !important;
            overflow: hidden;
          }
          
          /* Phase header on card */
          .table-cell::before {
            content: attr(data-phase);
            display: block;
            background: linear-gradient(135deg, #4da3d1 0%, #63b8ff 100%);
            color: white;
            padding: 20px;
            margin: 0;
            text-align: center;
            font-weight: 700;
            font-size: 1.1rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }
          
          /* Card content padding */
          .table-cell .cell-content {
            padding: 25px 20px;
          }

          /* Keep same background and animations */
          .table-cell {
            background: linear-gradient(180deg, #a1d6f6 0%, #d1eaf9 100%);
          }

          .table-cell:hover {
            background: linear-gradient(180deg, #e8faff 0%, #c1e8f9 100%);
            transform: none;
          }
          
          /* Adjust heading for mobile */
          .table-cell h5 {
            height: auto !important;
            min-height: unset !important;
            font-size: 1.3rem;
            margin-bottom: 12px;
          }
          
          /* Keep same list styling */
          .table-cell ul li {
            font-size: 1rem;
            line-height: 1.6;
            padding: 10px 0 10px 35px;
          }
          
          .table-cell ul li::before {
            top: 10px;
          }

          /* Keep same animations */
          .table-cell ul li:hover::before {
            transform: scale(1.15) rotate(360deg);
          }

          .line::after {
            animation: shimmer 3s infinite;
          }

          .progress-indicator {
            margin-top: 30px;
          }
          
          .progress-bar {
            max-width: 100%;
          }
        }

        /* =======================
           SMALL MOBILE
        ======================= */
        @media (max-width: 576px) {
          .phases-section {
            padding: 30px 0;
          }
          
          .main-title {
            font-size: 1.5rem;
          }
          
          .subtitle {
            font-size: 0.95rem;
          }
          
          .table-wrapper {
            padding: 10px;
          }
          
          .table-cell::before {
            font-size: 1rem;
            padding: 18px 15px;
          }
          
          .table-cell .cell-content {
            padding: 20px 15px;
          }
          
          .table-cell h5 {
            font-size: 1.15rem;
          }
          
          .table-cell ul li {
            font-size: 0.95rem;
            padding: 8px 0 8px 32px;
          }

          .table-cell ul li::before {
            width: 22px;
            height: 22px;
            font-size: 1.1rem;
          }
        }
      `}</style>
    </div>
  );
}